import { GET_DASHBOARD_DATA_CHANGES } from "constants/actionTypes";

export const requestDashBoardDataChanges = (sale, saleyard) => ({
  type: GET_DASHBOARD_DATA_CHANGES,
  sale,
  saleyard,
});
